module.exports = __webpack_public_path__ + "img/review.28b3e69d.png";